/**
 * Created by Sale on 6/4/2024
 */
import store from "./store";
import router from "./router";

export default {
    store,
    router
};